import { Divider, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  CardComponent,
  CostTrendChart,
  OverviewCardWithIcon,
  PageTitleAndSubTitle,
  ToggleGroup,
  Warning,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { observer } from 'mobx-react';
import React, { ChangeEvent, useEffect, useState } from 'react';
import TabSelection from '../../_components/molecules/TabSelection';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import Typography from '@HomaHealth/ui-component-library/lib/_patient-access-components/atoms/Typography';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { useStores } from '../../stores';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import Loader from '../../_components/molecules/Loader';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import savingsUtilizationMessages from '../../core-utils/messages/SavingsUtilizationMessages';
import Dollar from '../../_components/atoms/Icons/Dollar';
import Prescription from '../../_components/atoms/Icons/Prescription';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  formatFillsBreakdown,
  formatSavingsTable,
  formatSavingsTableData,
  formatSavingsUtilizationTopCards,
  getSavingsProgramColumns,
  getSubtitleForSavingsTable,
  getTotalPages,
} from '../../core-utils/helper-utils/savingsUtilizationHelper';
import { numFormatterWithSuffix } from '../../core-utils/helper-utils/helper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import DateFilter from '../../_components/molecules/DateFilter';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import noDataImg from '../../../public/Images/NoData.png';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import type { CSSObject } from 'tss-react';

export const NoDataVisual = ({
  text,
  rootStyles,
}: {
  text: string;
  rootStyles?: CSSObject;
}) => {
  const { classes } = makeStyles()({
    rootStyles: { height: '500px', display: 'flex', ...rootStyles },
    infoBar: {
      borderR: '4px',
      padding: '8px 16px',
      display: 'flex',
      gap: '10px',
      background: '#EDEFF4',
      alignItems: 'center',
    },
  })();
  return (
    <Grid className={classes.rootStyles}>
      <GifWithLabels
        mainLabel={
          <Grid className={classes.infoBar}>
            <Warning />
            <Typography
              fontSize="14px"
              lineHeight="22.4px"
              textColor={patientAccessTheme.palette.text.lowemphasis}
              fontType="medium"
            >
              {text}
            </Typography>
          </Grid>
        }
        subLabel={''}
        gifUrl={noDataImg}
      />
    </Grid>
  );
};

export interface SavingsUtilizationProps {}
const SavingsUtilization: React.FC<SavingsUtilizationProps> = observer(({}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '1182px',
      padding: '40px 0px 66px 63px',
    },
    container: {
      marginBottom: '36px',

      position: 'relative',
    },
    titleContainer: {
      position: 'absolute',
      top: '-1px',
      left: '184px',
      display: 'flex',
      alignItems: 'center',
    },
    flex: {
      display: 'flex',
    },
  });

  const OverViewCardStyles = {
    rootStyles: {
      width: '200px',
      height: '100px',
      padding: '18px 8px 12px 20px',
      justifyContent: 'space-between',
    },
    titleTypographyStyles: {
      fontSize: '14px',
      lineHeight: '24px',
      color: `${patientAccessTheme.palette.text.highemphasis}`,
      fontWeight: 600,
    },
    toolTipStyles: {
      width: '250px',
      fontSize: '12px',
      textAlign: 'justify' as 'justify',
    },
    valueStyles: {
      fontSize: '20px',
      lineHeight: '42px',
      color: `${patientAccessTheme.palette.text.highemphasis}`,
      fontWeight: 600,
      display: 'flex',
      gap: '0.3rem',
    },
  };

  const { classes } = useStyles();

  const [loading, setLoading] = useState<boolean>(false);
  const [loader] = useState<any>(<Loader />);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [toggleState, setToggleState] = React.useState<'left' | 'right'>(
    'left',
  );

  const [costSavings, setCostSavings] = useState<any>({});
  const [prescriptionFills, setPrescriptionFills] = useState<any>({});
  const [planPaid, setPlanPaid] = useState<any>({});
  const [rxCost, setRxCost] = useState<any>({});
  const [costTrendData, setCostTrendData] = useState<any>({});
  const [fillsBreakdown, setFillsBreakdown] = useState<any>({});
  const [tableData, setTableData] = useState<any[]>([]);
  const [savingsProgramExists, setSavingsProgramExists] = useState<boolean>(
    false,
  );

  const messages = savingsUtilizationMessages;
  const employerGroupStore = useStores().employerGroupStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handlePageChange = (
    event: ChangeEvent<unknown>,
    page: number,
    tableId: string,
    program: string,
  ) => {
    setTableData((prevTablesData) =>
      prevTablesData.map((table) =>
        table.id === tableId ? { ...table, loading: true } : table,
      ),
    );
    getSavingsProgramDetails(program, page - 1).then((res) => {
      const response = res.data?.data[0];
      setTableData((prevTablesData) =>
         
        prevTablesData.map((table) =>
          table.id === tableId
            ? {
                ...table,
                loading: false,
                pageNumber: page,
                details: response?.details,
              }
            : table,
        ),
      );
    });
  };

  const getSavingsUtilizatonSummary = async (signal: AbortSignal) => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.savingsUtilizationBaseUrl +
        properties.savingsUtilizatonSummary,
      {
        ...payload,
        member_unique_id_list: [],
      },
      { signal },
    );
  };
  const getFillsAndBreakdownCostTrend = async (signal: AbortSignal) => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.savingsUtilizationBaseUrl +
        properties.fillsAndBreakdownCostTrend,
      {
        ...payload,
        member_unique_id_list: [],
      },
      { signal },
    );
  };
  const getSavingsProgramDetails = async (
    program: string,
    pageNumber: number,
    signal?: AbortSignal,
  ) => {
    return axios.post(
      properties.aiqBaseUrl +
        properties.savingsUtilizationBaseUrl +
        properties.savingsProgramDetails,
      {
        ...payload,
        member_unique_id_list: [],
        program: program,
        pageNumber: pageNumber,
      },
      { signal },
    );
  };

  const TopCards = () => {
    const {
      rootStyles,
      titleTypographyStyles,
      toolTipStyles,
      valueStyles,
    } = OverViewCardStyles;

    const topCardsToolTipContent = (
      type: string,
      field?: any,
      value?: any,
      totalField?: any,
    ) => {
      let title: string = '';

      switch (value) {
        case 'costSavings':
          title = 'Cost Savings';
          break;
        case 'rxCost':
          title = 'Rx Cost';
          break;
        case 'planPaid':
          title = 'Plan Paid';
          break;

        default:
          break;
      }

      return (
        <Grid
          className={classes.flex}
          style={{ gap: '0.2rem', flexDirection: 'column' }}
        >
          {type === 'cost' ? (
            <Typography fontSize="12px" fontType="regular">
              {title} - <b>${numFormatterWithSuffix(field?.[totalField])}</b>
            </Typography>
          ) : (
            <Typography fontSize="12px" fontType="regular">
              Prescription Fills - <b>{prescriptionFills.totalfills}</b>
            </Typography>
          )}
          <Divider
            style={{
              backgroundColor: patientAccessTheme.palette.status.white,
              marginBottom: '6px',
            }}
          />
          {type === 'cost'
            ? field?.[value]?.map((item: any) => (
                <Typography fontSize="12px" fontType="regular">
                  {item.program} - <b>${numFormatterWithSuffix(item.cost)}</b>
                </Typography>
              ))
            : prescriptionFills?.prescriptionFills?.map((item: any) => (
                <Typography fontSize="12px" fontType="regular">
                  {item.program} - <b>{item.fills}</b>
                </Typography>
              ))}
        </Grid>
      );
    };

    return (
      <Grid className={classes.flex} style={{ gap: '1rem' }}>
        {costSavings?.totalSavings > 0 && (
          <OverviewCardTooltipContent
            type="cost"
            customTitle={topCardsToolTipContent(
              'cost',
              costSavings,
              'costSavings',
              'totalSavings',
            )}
            overviewCard={
              <OverviewCardWithIcon
                title={messages.TOP_CARDS.COST_SAVINGS}
                values={[
                  [
                    `$${numFormatterWithSuffix(costSavings.totalSavings, 2)}`,
                    '',
                  ],
                ]}
                rootStyles={rootStyles}
                titleTypographyStyles={titleTypographyStyles}
                toolTipContent={''}
                toolTipStyles={toolTipStyles}
                valueStyles={valueStyles}
              />
            }
          />
        )}
        <OverviewCardTooltipContent
          type="cost"
          customTitle={topCardsToolTipContent('fills')}
          overviewCard={
            <OverviewCardWithIcon
              title={messages.TOP_CARDS.PRESCRIPTION_FILLS}
              values={[[`${prescriptionFills.totalfills}`, '']]}
              rootStyles={rootStyles}
              titleTypographyStyles={titleTypographyStyles}
              toolTipContent={''}
              toolTipStyles={toolTipStyles}
              valueStyles={valueStyles}
            />
          }
        />
        <OverviewCardTooltipContent
          type="cost"
          customTitle={topCardsToolTipContent(
            'cost',
            rxCost,
            'rxCost',
            'totalCost',
          )}
          overviewCard={
            <OverviewCardWithIcon
              title={messages.TOP_CARDS.RX_COST}
              values={[
                [`$${numFormatterWithSuffix(rxCost?.totalCost, 2)}`, ''],
              ]}
              rootStyles={rootStyles}
              titleTypographyStyles={titleTypographyStyles}
              toolTipContent={''}
              toolTipStyles={toolTipStyles}
              valueStyles={valueStyles}
            />
          }
        />
        <OverviewCardTooltipContent
          type="cost"
          customTitle={topCardsToolTipContent(
            'cost',
            planPaid,
            'planPaid',
            'totalPlanPaid',
          )}
          overviewCard={
            <OverviewCardWithIcon
              title={messages.TOP_CARDS.PLAN_PAID}
              values={[
                [`$${numFormatterWithSuffix(planPaid?.totalPlanPaid, 2)}`, ''],
              ]}
              rootStyles={rootStyles}
              titleTypographyStyles={titleTypographyStyles}
              toolTipContent={''}
              toolTipStyles={toolTipStyles}
              valueStyles={valueStyles}
            />
          }
        />
      </Grid>
    );
  };
  const FillsAndSavingsBreakDown = () => {
    const CostTrendProps = () => {
      return {
        showDBIcon: false,
        chartTitle: 'Prescription Fills and Plan Paid Breakdown',
        chartSubTitle:
          'Use the toggle on the right to show breakdown based on prescription fills and Plan Paid cost',
        showClickHere: false,
        cardWidth: '1182px',
        cardHeight: '458px',
        datasetProp: fillsBreakdown?.costTrendData,
        chartWidth: '1100',
        chartHeight: '320',
        yAxisTitle: toggleState === 'left' ? 'Cost' : 'Volume of fills',
        sAxisTitle: ' ',
        chartType: 'stackedcolumn2d',
        xAxisValues: fillsBreakdown?.xAxisValues,
        numberPrefix: toggleState === 'left' ? '$' : '',
        showLegend: '1',
        spaceBetweenTitleAndChart: '24px',
      };
    };

    return (
      <CostTrendChart
        {...CostTrendProps()}
        topRightItem={
          <ToggleGroup
            leftValue={'Cost'}
            rightValue={'Fills'}
            leftIcon={<Dollar style={{ height: '16px', width: '16px' }} />}
            rightIcon={
              <Prescription
                stroke={patientAccessTheme.palette.primary[500]}
                strokeWidth="0.4px"
                style={{ height: '16px', width: '16px' }}
              />
            }
            setSelectedToggle={setToggleState}
          />
        }
      />
    );
  };

  const SavingsProgramTables = () => {
    return (
      <>
        {tableData?.map((item: any) => (
          <CardComponent
            title={item?.savings_program}
            subTitle={getSubtitleForSavingsTable(
              item?.drugCount,
              item?.claimCounts,
              item?.planPaid,
              item?.totalSavings,
            )}
            body={
              <>
                {item?.loading ? (
                  <CircularLoader />
                ) : (
                  <BasicTable
                    displayType="row"
                    columns={getSavingsProgramColumns(
                      item?.totalSavings,
                      item?.columnName,
                    )}
                    rowsData={formatSavingsTableData(
                      item?.details,
                      item?.totalSavings,
                    )}
                    headerCellHeight="46px"
                    showPagination={true}
                    width="1100px"
                    tableHeight="auto"
                    cellHeight="46px"
                    cellPadding="12px 9px 12px 14px"
                    showOnHoverHeader={true}
                    pageCount={getTotalPages(item?.drugCount)}
                    handlePagination={(
                      event: ChangeEvent<unknown>,
                      page: number,
                    ) =>
                      handlePageChange(
                        event,
                        page,
                        item?.id,
                        item?.savings_program,
                      )
                    }
                    pageNumber={item?.pageNumber}
                  />
                )}
              </>
            }
            height={item?.drugCount > 9 ? '710px' : 'auto'}
          />
        ))}
      </>
    );
  };

  const apiCalls = async (abortController: AbortController) => {
    setLoading(true);

    isPlanDatesFetched &&
      (await Promise.allSettled([
        getSavingsUtilizatonSummary(abortController.signal),
        getFillsAndBreakdownCostTrend(abortController.signal),
        getSavingsProgramDetails('', 0, abortController.signal),
      ])
        .then((responses) => {
          setLoading(false);

          if (responses[0]?.status === 'fulfilled') {
            setSavingsProgramExists(
              responses[0].value.data?.data.length === 0 ? false : true,
            );
            formatSavingsUtilizationTopCards(
              responses[0].value.data?.data,
              setCostSavings,
              setPrescriptionFills,
              setRxCost,
              setPlanPaid,
            );
          }
          if (responses[1]?.status === 'fulfilled') {
            setCostTrendData(responses[1].value.data?.data);
            setFillsBreakdown(
              formatFillsBreakdown(responses[1].value.data?.data, toggleState),
            );
          }
          if (responses[2]?.status === 'fulfilled') {
            setTableData(formatSavingsTable(responses[2].value.data?.data));
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
          } else {
            console.error('API call failed:', error);
          }
        })
        .finally(() => {
          setLoading(false);
        }));
    setLoading(false);
  };

  useEffect(() => {
    apiCalls(abortController);

    return () => {
      abortController.abort();
    };
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);

  useEffect(() => {
    if (costTrendData?.costTrend?.length > 0) {
      const formattedData = formatFillsBreakdown(costTrendData, toggleState);
      setFillsBreakdown(formattedData);
    }
  }, [toggleState]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  return (
    <>
      {isPlanDatesLoading || loading ? (
        loader
      ) : (
        <div>
          <Grid container className={classes.root}>
            <Grid className={classes.container}>
              <PageTitleAndSubTitle
                title={messages.TITLE}
                chip={
                  <Grid className={classes.flex}>
                    <Typography
                      fontSize="17px"
                      lineHeight="21px"
                      textColor={patientAccessTheme.palette.text.mediumemphasis}
                      fontType="semiBold"
                      margin="2px 8px 0px 0px"
                    >
                      for
                    </Typography>
                    <DateFilter />
                  </Grid>
                }
                subTitle={messages.SUBTITLE}
                showDownloadButton
                downloadButtonAction={() => setOpenReportsModal(true)}
              />
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>
            <Grid>
              {selectedTabIndex === 0 && (
                <Grid
                  className={classes.flex}
                  style={{ flexDirection: 'column', gap: '1rem' }}
                >
                  {savingsProgramExists ? (
                    <>
                      <TopCards />
                      <FillsAndSavingsBreakDown />
                      <SavingsProgramTables />
                    </>
                  ) : (
                    <NoDataVisual text="The chosen group does not have any Drug Savings Program at present" />
                  )}
                </Grid>
              )}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                  isInternalPage={true}
                />
              )}
            </Grid>
          </Grid>
        </div>
      )}
      {/**
       * TODO: Update the below component with Incurred Dates and Paid Dates
       */}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
    </>
  );
});
export default SavingsUtilization;
